import sumBy from 'lodash/sumBy';
import uniq from 'lodash/uniq';

import {
  campaignLineStatuses,
  complianceStatuses,
} from '../../campaign-editor/constants';

const { DRAFT, READY, PUSHED, LOCKED } = campaignLineStatuses;

export const getStatusBarItems = data => {
  const linesByStatus = data.campaignLinesByStatus;
  return [DRAFT, READY, PUSHED, LOCKED].map(s => ({
    status: s,
    count: linesByStatus[s] ? linesByStatus[s] : 0,
  }));
};

export const getCollaboratorNumbers = (collaboratorIds, users) =>
  collaboratorIds.map(userId => users.find(user => user.id === userId).number);

export const getUserNumber = (userId, users) =>
  userId ? users.find(user => user.id === userId).number : null;

export const getNumberOfLinesWithStatus = (campaignLines, status) =>
  campaignLines.filter(line => line.status === status).length;

export const getUniqueGenders = campaignLines =>
  uniq(campaignLines.map(line => line.gender));

export const getCoinvestSum = campaignLines =>
  sumBy(campaignLines, line => Number(line.coInvest));

export const getOpsCompliancePercentage = campaignLines => {
  const numberOfCampaignLines = campaignLines.length;
  const compliantCampaignLines = campaignLines.filter(
    item => item.opsHandoverCompliance === complianceStatuses.COMPLIANT,
  ).length;
  const result = (compliantCampaignLines / numberOfCampaignLines) * 100;
  return result;
};
